<template>
  <!-- 首页-专利检索部分 -->
  <div class="search-commonbox search-patentbox">
    <el-radio-group class="common-radiobox patent-radiobox" v-model="patentRadio" @change="panentSelectChange">
      <el-radio-button value="all" label="all">全部</el-radio-button>
      <el-radio-button value="tsc,ds" label="tsc,ds">关键词</el-radio-button>
      <el-radio-button value="all" label="ap,pa">申请人/专利权人</el-radio-button>
      <el-radio-button value="all" label="in">发明人</el-radio-button>
      <el-radio-button value="all" label="ag,ac">代理机构/代理人</el-radio-button>
      <el-radio-button value="all" label="apad,paad">地址</el-radio-button>
      <el-radio-button value="all" label="ics">IPC分类</el-radio-button>
      <el-radio-button value="all" label="an,pn,prn">专利号码</el-radio-button>
    </el-radio-group>
    <div class="common-querybox patent-querybox">
      <div class="comquery-inputbox">
        <el-input
          class="inputbox-input"
          v-model="patentQueryValue"
          placeholder="请输入关键字搜索"
          @keyup.enter.native="isLogin(1)"
        ></el-input>
        <el-button class="inputbox-btn" @click="isLogin(1)">搜索</el-button>
      </div>
      <span class="comquery-advanced" @click="isLogin(2)">高级搜索</span>
      <!-- <router-link class="comquery-advanced" to="/">高级查询</router-link> -->
    </div>
    <div class="common-comcheckbox">
      <el-checkbox-group class="comcheckbox-group" v-model="patentCheckAreaList" @change="panentAreaChange">
        <el-checkbox label="co=(cn or hk or mo or tw)">中国</el-checkbox>
        <el-checkbox label="not co=(cn or hk or mo or tw)">其他国家/地区</el-checkbox>
      </el-checkbox-group>
      <el-checkbox-group class="comcheckbox-group" v-model="patentCheckTypeList" @change="panentTypeChange">
        <el-checkbox label="1">发明</el-checkbox>
        <el-checkbox label="2">实用新型</el-checkbox>
        <el-checkbox label="3">外观设计</el-checkbox>
      </el-checkbox-group>
      <el-checkbox-group class="comcheckbox-group" v-model="patentCheckLsList" @change="panentLsChange">
        <el-checkbox label="1">未授权</el-checkbox>
        <el-checkbox label="2">有效</el-checkbox>
        <el-checkbox label="3">失效</el-checkbox>
      </el-checkbox-group>
    </div>
    <div class="common-inforcon">
      <p class="inforcon-inforp">
        数据覆盖：全球 {{ patentResult.countryCount | num }} 个国家和地区的 {{ patentResult.patentCount | num }} 件专利
      </p>
      <p class="inforcon-inforp">最近更新：{{ patentResult.date | time }}</p>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      patentRadio: 'all', // 专利检索-单选
      patentQueryValue: '', // 专利检索-关键字
      patentCheckAreaList: ['co=(cn or hk or mo or tw)', 'not co=(cn or hk or mo or tw)'], // 专利检索-多选-地区
      patentAreaVal: '', // 专利检索-多选-地区-条件拼接成字符串
      patentCheckTypeList: ['1', '2', '3'], // 专利检索-多选-类型
      patentTypeVal: '', // 专利检索-多选-类型-条件拼接成字符串
      patentCheckLsList: ['1', '2', '3'], // 专利检索-多选-授权
      patentLsVal: '', // 专利检索-多选-授权-条件拼接成字符串
      patentSelectedArray: [], // 复选框条件-三组复选框合成一个数组
      patentResult: {} // 数量和更新时间
    }
  },
  props: {
    activeIndex: {
      type: String,
      default() {
        return '1'
      }
    }
  },
  filters: {
    time(val) {
      if (!val) return ''
      val = val.toString()
      return val.substring(0, 4) + '/' + val.substring(4, 6) + '/' + val.substring(6, 8)
    },
    num(val) {
      if (!val) return '0'
      val = val.toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,')
      return val
    }
  },
  created() {
    this.getInfo()
  },
  methods: {
    getInfo() {
      this.$axios({
        method: 'get',
        url: '/patent/updateInfo'
      }).then((res) => {
        this.patentResult = res.data
        // console.log(res)
      })
    },
    // 专利检索-单选
    panentSelectChange: function () {
      console.log(this.patentRadio)
      // this.patentQueryValue = ''
    },
    // 专利检索-地区-复选框
    panentAreaChange: function () {
      let _this = this
      if (_this.patentCheckAreaList.length == 1) {
        _this.patentAreaVal = _this.patentCheckAreaList[0]
      } else {
        _this.patentAreaVal = ''
      }
    },
    // 专利检索-类型-复选框
    panentTypeChange: function () {
      let _this = this
      console.log(_this.patentCheckTypeList)
      if (_this.patentCheckTypeList.length == 1) {
        _this.patentTypeVal = 'pt =(' + _this.patentCheckTypeList[0] + ')'
      } else if (_this.patentCheckTypeList.length == 2) {
        _this.patentTypeVal = 'pt =(' + _this.patentCheckTypeList[0] + ' OR ' + _this.patentCheckTypeList[1] + ')'
      } else {
        _this.patentTypeVal = ''
      }
    },
    // 专利检索-是否授权-复选框
    panentLsChange: function () {
      let _this = this
      console.log(_this.patentCheckLsList)
      if (_this.patentCheckLsList.length == 1) {
        _this.patentLsVal = 'ls=(' + _this.patentCheckLsList[0] + ')'
      } else if (_this.patentCheckLsList.length == 2) {
        _this.patentLsVal = 'ls=(' + _this.patentCheckLsList[0] + ' OR ' + _this.patentCheckLsList[1] + ')'
      } else {
        _this.patentLsVal = ''
      }
    },
    // 专利检索-点击搜索
    patentSearchHandle: function () {
      let _this = this
      // 获取复选框-选中的条件
      _this.patentSelectedArray = []
      if (_this.patentAreaVal) {
        _this.patentSelectedArray.push(_this.patentAreaVal)
      }
      if (_this.patentTypeVal) {
        _this.patentSelectedArray.push(_this.patentTypeVal)
      }
      if (_this.patentLsVal) {
        _this.patentSelectedArray.push(_this.patentLsVal)
      }
      console.log(_this.patentSelectedArray)
      let patentFiledQ = '' // 获取选中复选框条件-拼接
      for (let i = 0; i < _this.patentSelectedArray.length; i++) {
        if (i == _this.patentSelectedArray.length - 1) {
          patentFiledQ += _this.patentSelectedArray[i]
        } else {
          patentFiledQ += _this.patentSelectedArray[i] + ' AND '
        }
      }
      let patentInputVal = this.patentQueryValue.replace(/(^\s*)|(\s*$)/g, '') // 获取输入框内容-去掉输入内容的前后空格
      let fieldArr = this.patentRadio.split(',') // 获取输入框上方单选的内容
      let patentSearchQ = '' // 获取输入内容的条件
      console.log(fieldArr)
      if (patentInputVal) {
        // 如果-输入框关键字不为空，则拼接检索式
        for (let i = 0; i < fieldArr.length; i++) {
          if (patentSearchQ.length > 0) patentSearchQ += ' or '
          if (fieldArr[i] != 'all') patentSearchQ += fieldArr[i] + '=(' + patentInputVal + ')'
          else patentSearchQ = patentInputVal
        }
      }
      if (patentSearchQ) patentSearchQ = '((' + patentSearchQ + '))'
      let patentTempQuery = [] // 检索条件-数组
      let patentQuery = '' // 获取拼接成的条件进行检索
      if (patentSearchQ) patentTempQuery.push(patentSearchQ)
      if (patentFiledQ) patentTempQuery.push(patentFiledQ)
      for (let i = 0; i < patentTempQuery.length; i++) {
        if (i == patentTempQuery.length - 1) {
          patentQuery += patentTempQuery[i]
        } else {
          patentQuery += patentTempQuery[i] + ' AND '
        }
      }
      console.log('专利检索条件--' + patentQuery)
      // _this.$router.push( // 携带参数-跳转页面
      //   {
      //     path: '/patent/list',
      //     query: {
      //       patentQuery: patentQuery
      //     }
      //   }
      // )
      // 跳转页面
      // let { href } = this.$router.resolve({
      //   path: '/patent/list',
      //   query: { patentQuery: patentQuery }
      // })
      // window.open(href, '_blank') // 跳转新页面打开-实现方式
      // window.open(`http://baotou.areaip.cn/open/free_list?q=${patentQuery}`, '_blank')
      location.href = this.urlUser + '/db/list/1?q=' + patentQuery
    },
    isLogin(val) {
      this.$axios({
        method: 'get',
        url: '/service/user/userinfo',
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      })
        .then((res) => {
          if (val == 1) {
            this.patentSearchHandle()
          } else if (val == 2) {
            // window.open()
            window.open(this.urlUser + '/db/advanced/', '_self')
          }
        })
        .catch((err) => {
          if (err.response.status == 401) {
            // 显示登录弹框
            let showLogin = this.$store.state.showLogin
            this.$store.commit('changeShowLogin', !showLogin)
          }
        })
    }
    // 以上是专利检索条件内容----------------------------------------------------------------------------------
  }
}
</script>

<style scoped>
/* 检索部分 */
.search-commonbox {
  text-align: left;
}
/* 单选框 */
.common-radiobox {
  margin: 20px 0 10px;
}
.common-radiobox .el-radio-button__inner {
  display: block;
  float: left;
  padding: 0 10px;
  height: 24px;
  line-height: 24px;
  border: none !important;
  border-radius: 0;
  box-sizing: border-box;
  color: #333333;
  cursor: pointer;
}
.common-radiobox .el-radio-button__inner:hover {
  color: #333333;
}
.common-radiobox .el-radio-button__orig-radio:checked + .el-radio-button__inner {
  background: none;
  box-shadow: none;
  color: #333333;
  font-weight: 700;
}
/* 搜索框 */
.common-querybox {
  position: relative;
  margin-bottom: 10px;
  height: 40px;
}
.comquery-inputbox {
  position: relative;
  float: left;
  width: 1000px;
}
.inputbox-input {
  display: block;
}
.inputbox-input .el-input__inner {
  display: block;
  margin: 0;
  padding: 0 52px 0 10px;
  width: 1000px;
  height: 40px;
  line-height: 40px;
  border: 1px solid rgba(121, 121, 121, 1);
  border-radius: 0;
  background: #ffffff;
  outline: none;
  box-sizing: border-box;
  color: #333333;
  font-size: 14px;
}
.inputbox-input .el-input__inner:focus {
  border: 1px solid #050162;
}
.inputbox-btn {
  position: absolute;
  top: 1px;
  right: 0px;
}
.comquery-inputbox .el-button {
  padding: 0px 10px;
  height: 38px;
  line-height: 38px;
  border: none;
  background: none;
  border-radius: 0;
  border-top-right-radius: 3px;
  border-bottom-right-radius: 3px;
  box-sizing: border-box;
  outline: none;
  color: #d42a2a;
  font-weight: 700;
  font-size: 16px;
}
.common-querybox .comquery-advanced {
  position: absolute;
  top: 0;
  right: 0px;
  display: block;
  line-height: 42px;
  font-weight: 400;
  font-size: 12px;
  cursor: pointer;
}
/* 复选框 */
.common-comcheckbox {
  margin-bottom: 20px;
  padding-left: 5px;
  text-align: left;
  box-sizing: border-box;
  font-size: 12px;
}
.common-comcheckbox:after {
  display: block;
  content: '';
  clear: both;
}
.comcheckbox-group {
  display: block;
  float: left;
  margin: 0 10px 0 0;
}
.common-comcheckbox .el-checkbox {
  display: block;
  float: left;
  margin-right: 10px;
}
.comcheckbox-group .el-checkbox__label {
  padding-left: 6px;
  color: #333333 !important;
}
.el-checkbox__input.is-checked .el-checkbox__inner,
.el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background: #d42a2a;
  border-color: #d42a2a;
}
/* 更新时间说明 */
.common-inforcon {
  margin-left: 5px;
}
.inforcon-inforp {
  color: #d42a2a;
  font-weight: 700;
  font-size: 12px;
}
</style>
